/** DB에는 문자열 "null", 화면에는 빈 칸 */
export const junctionBoxYnToDisplay = (value) => {
  if (value == null || value === '') return '';
  if (String(value).toLowerCase() === 'null') return '';
  return String(value);
};

export const junctionBoxYnForApi = (value) => {
  if (value == null) return 'null';
  const s = String(value).trim();
  if (s === '' || s.toLowerCase() === 'null') return 'null';
  return s;
};

const getNowDatetimeLocal = () => {
  const now = new Date();
  now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
  return now.toISOString().slice(0, 16);
};

export const applyPostFormFieldChange = (prev, name, value) => {
  const next = { ...prev, [name]: value };

  if (name === 'receiptStatus' && value === 'COMPLETED') {
    next.processedAt = getNowDatetimeLocal();
  }

  return next;
};

export const createInitialPostForm = () => ({
  receivedCompany: '',
  receivedBy: '',
  installationYear: '',
  businessName: '',
  managementNumber: '',
  proposer: '',
  proposerPhoneNumber: '',
  possessor: '',
  possessorPhoneNumber: '',
  zipcode: '',
  address: '',
  detailAddress: '',
  receiptStatus: 'RECEIVED',
  installationCompany: '',
  contractorManager: '',
  contractorPhoneNumber: '',
  moduleManufacturer: '',
  moduleModelName: '',
  moduleQuantity: '',
  inverterManufacturer: '',
  inverterModelName: '',
  ratedVoltage: '',
  capacity: '',
  inverterQuantity: '',
  inverterCapacity: '',
  junctionBoxYn: '',
  issueDescription: '',
  processedBy: '',
  resolution: '',
  receivedAt: getNowDatetimeLocal(),
  processedAt: '',
});

const normalizeString = (value) => {
  if (value === '' || value === null || value === undefined) {
    return null;
  }
  return String(value).trim();
};

const optionalIntForApi = (value) => {
  if (value === '' || value === null || value === undefined) return null;
  const n = parseInt(String(value).replace(/,/g, '').trim(), 10);
  return Number.isFinite(n) ? n : null;
};

const optionalDoubleForApi = (value) => {
  if (value === '' || value === null || value === undefined) return null;
  const n = parseFloat(String(value).replace(/,/g, '').trim());
  return Number.isFinite(n) ? n : null;
};

export const mapPostToForm = (post) => ({
  ...createInitialPostForm(),
  ...post,
  proposerPhoneNumber: post?.proposerPhoneNumber ?? '',
  possessorPhoneNumber: post?.possessorPhoneNumber ?? '',
  zipcode: post?.zipcode ?? '',
  contractorPhoneNumber: post?.contractorPhoneNumber ?? '',
  moduleQuantity: post?.moduleQuantity != null ? String(post.moduleQuantity) : '',
  ratedVoltage: post?.ratedVoltage != null ? String(post.ratedVoltage) : '',
  inverterQuantity: post?.inverterQuantity != null ? String(post.inverterQuantity) : '',
  capacity: post?.capacity != null ? String(post.capacity) : '',
  inverterCapacity: post?.inverterCapacity != null ? String(post.inverterCapacity) : '',
  receivedAt: post?.receivedAt ? post.receivedAt.slice(0, 16) : '',
  processedAt: post?.processedAt ? post.processedAt.slice(0, 16) : '',
  junctionBoxYn: junctionBoxYnToDisplay(post?.junctionBoxYn),
});

export const buildPostPayload = (form) => ({
  receivedCompany: form.receivedCompany,
  receivedBy: form.receivedBy,
  installationYear: normalizeString(form.installationYear),
  businessName: normalizeString(form.businessName),
  managementNumber: normalizeString(form.managementNumber),
  proposer: form.proposer,
  proposerPhoneNumber: normalizeString(form.proposerPhoneNumber),
  possessor: form.possessor,
  possessorPhoneNumber: normalizeString(form.possessorPhoneNumber),
  zipcode: normalizeString(form.zipcode),
  address: form.address || null,
  detailAddress: form.detailAddress,
  receiptStatus: form.receiptStatus,
  installationCompany: form.installationCompany || null,
  contractorManager: form.contractorManager || null,
  contractorPhoneNumber: normalizeString(form.contractorPhoneNumber),
  moduleManufacturer: form.moduleManufacturer || null,
  moduleModelName: form.moduleModelName || null,
  moduleQuantity: optionalIntForApi(form.moduleQuantity),
  inverterManufacturer: form.inverterManufacturer || null,
  inverterModelName: form.inverterModelName || null,
  ratedVoltage: optionalIntForApi(form.ratedVoltage),
  capacity: optionalDoubleForApi(form.capacity),
  inverterQuantity: optionalIntForApi(form.inverterQuantity),
  inverterCapacity: optionalDoubleForApi(form.inverterCapacity),
  junctionBoxYn: junctionBoxYnForApi(form.junctionBoxYn),
  issueDescription: form.issueDescription,
  processedBy: form.processedBy || null,
  resolution: form.resolution || null,
  receivedAt: form.receivedAt ? new Date(form.receivedAt).toISOString() : null,
  processedAt: form.processedAt ? new Date(form.processedAt).toISOString() : null,
});

export const mapConstructionToPostForm = (construction) => {
  const base = createInitialPostForm();
  if (!construction) return base;

  return {
    ...base,
    installationYear: construction.installationYear ?? '',
    businessName: construction.businessName ?? '',
    managementNumber: construction.managementNumber ?? '',
    proposer: construction.possessor ?? '',
    proposerPhoneNumber: construction.possessorPhoneNumber ?? '',
    possessor: construction.possessor ?? '',
    possessorPhoneNumber: construction.possessorPhoneNumber ?? '',
    address: construction.address ?? '',
    detailAddress: construction.detailAddress ?? '',
    installationCompany: construction.installationCompany ?? '',
    contractorManager: construction.contractorManager ?? '',
    contractorPhoneNumber: construction.contractorPhoneNumber ?? '',
    moduleManufacturer: construction.moduleManufacturer ?? '',
    moduleModelName: construction.moduleModelName ?? '',
    moduleQuantity: construction.moduleQuantity != null ? String(construction.moduleQuantity) : '',
    inverterManufacturer: construction.inverterManufacturer ?? '',
    inverterModelName: construction.inverterModelName ?? '',
    ratedVoltage: construction.ratedVoltage != null ? String(construction.ratedVoltage) : '',
    capacity: construction.capacity != null ? String(construction.capacity) : '',
    inverterQuantity: construction.inverterQuantity != null ? String(construction.inverterQuantity) : '',
    inverterCapacity: construction.inverterCapacity != null ? String(construction.inverterCapacity) : '',
    junctionBoxYn: junctionBoxYnToDisplay(construction.junctionBoxYn),
  };
};
